/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCareHomeHealthCreatePatientInput
 */
export interface MatrixCareHomeHealthCreatePatientInput {
    /**
     * 
     */
    businessUnitId: string;
    /**
     * 
     */
    businessUnitName: string;
    /**
     * 
     */
    lineOfBusinessId: string;
    /**
     * 
     */
    lineOfBusinessName: string;
    /**
     * MatrixCare LOB category, e.g. "Home Health" or "Hospice". Copy from the lookup response.
     */
    lineOfBusinessType: string;
    /**
     * Required for Hospice LOBs. Encodes 1 = first 90-day period, 2 = second 90-day period, 3+ = Nth 60-day recert.
     */
    startingCertPeriod?: number;
    /**
     * 
     */
    facilityDischargeTypeId?: string;
    /**
     * 
     */
    isShortStayAcuteHospital?: boolean;
    /**
     * 
     */
    forObservationOnly?: boolean;
    /**
     * 
     */
    referralSourceId?: string;
    /**
     * MatrixCare referral organization GUID selected from the organization lookup.
     */
    organizationId?: string;
    /**
     * MatrixCare referral organization display name selected from the organization lookup.
     */
    organizationName?: string;
    /**
     * M/D/YYYY
     */
    referralDate: string;
    /**
     * M/D/YYYY
     */
    scheduledSocDate?: string;
    /**
     * M/D/YYYY
     */
    physicianOrderedSocDate?: string;
    /**
     * M/D/YYYY
     */
    facilityDischargeDate?: string;
    /**
     * 
     */
    firstName: string;
    /**
     * 
     */
    middleName?: string;
    /**
     * 
     */
    lastName: string;
    /**
     * 
     */
    suffix?: string;
    /**
     * 9 digits, no hyphens.
     */
    ssn?: string;
    /**
     * M/D/YYYY
     */
    dateOfBirth?: string;
    /**
     * 
     */
    age?: number;
    /**
     * 
     */
    nickname?: string;
    /**
     * 
     */
    preferredPronouns?: string;
    /**
     * 
     */
    raceId?: string;
    /**
     * 
     */
    ethnicityId?: string;
    /**
     * 
     */
    genderId: string;
    /**
     * 
     */
    maritalStatusId?: string;
    /**
     * 
     */
    livesAloneId?: string;
    /**
     * 
     */
    sexualOrientationId?: string;
    /**
     * 
     */
    genderIdentityId?: string;
    /**
     * 
     */
    religionId?: string;
    /**
     * 
     */
    homePhone?: string;
    /**
     * 
     */
    mobilePhone?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    notifications?: string;
}

/**
 * Check if a given object implements the MatrixCareHomeHealthCreatePatientInput interface.
 */
export function instanceOfMatrixCareHomeHealthCreatePatientInput(value: object): value is MatrixCareHomeHealthCreatePatientInput {
    if (!('businessUnitId' in value) || value['businessUnitId'] === undefined) return false;
    if (!('businessUnitName' in value) || value['businessUnitName'] === undefined) return false;
    if (!('lineOfBusinessId' in value) || value['lineOfBusinessId'] === undefined) return false;
    if (!('lineOfBusinessName' in value) || value['lineOfBusinessName'] === undefined) return false;
    if (!('lineOfBusinessType' in value) || value['lineOfBusinessType'] === undefined) return false;
    if (!('referralDate' in value) || value['referralDate'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('genderId' in value) || value['genderId'] === undefined) return false;
    return true;
}

export function MatrixCareHomeHealthCreatePatientInputFromJSON(json: any): MatrixCareHomeHealthCreatePatientInput {
    return MatrixCareHomeHealthCreatePatientInputFromJSONTyped(json, false);
}

export function MatrixCareHomeHealthCreatePatientInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareHomeHealthCreatePatientInput {
    if (json == null) {
        return json;
    }
    return {
        
        'businessUnitId': json['businessUnitId'],
        'businessUnitName': json['businessUnitName'],
        'lineOfBusinessId': json['lineOfBusinessId'],
        'lineOfBusinessName': json['lineOfBusinessName'],
        'lineOfBusinessType': json['lineOfBusinessType'],
        'startingCertPeriod': json['startingCertPeriod'] == null ? undefined : json['startingCertPeriod'],
        'facilityDischargeTypeId': json['facilityDischargeTypeId'] == null ? undefined : json['facilityDischargeTypeId'],
        'isShortStayAcuteHospital': json['isShortStayAcuteHospital'] == null ? undefined : json['isShortStayAcuteHospital'],
        'forObservationOnly': json['forObservationOnly'] == null ? undefined : json['forObservationOnly'],
        'referralSourceId': json['referralSourceId'] == null ? undefined : json['referralSourceId'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'referralDate': json['referralDate'],
        'scheduledSocDate': json['scheduledSocDate'] == null ? undefined : json['scheduledSocDate'],
        'physicianOrderedSocDate': json['physicianOrderedSocDate'] == null ? undefined : json['physicianOrderedSocDate'],
        'facilityDischargeDate': json['facilityDischargeDate'] == null ? undefined : json['facilityDischargeDate'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'age': json['age'] == null ? undefined : json['age'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'preferredPronouns': json['preferredPronouns'] == null ? undefined : json['preferredPronouns'],
        'raceId': json['raceId'] == null ? undefined : json['raceId'],
        'ethnicityId': json['ethnicityId'] == null ? undefined : json['ethnicityId'],
        'genderId': json['genderId'],
        'maritalStatusId': json['maritalStatusId'] == null ? undefined : json['maritalStatusId'],
        'livesAloneId': json['livesAloneId'] == null ? undefined : json['livesAloneId'],
        'sexualOrientationId': json['sexualOrientationId'] == null ? undefined : json['sexualOrientationId'],
        'genderIdentityId': json['genderIdentityId'] == null ? undefined : json['genderIdentityId'],
        'religionId': json['religionId'] == null ? undefined : json['religionId'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'mobilePhone': json['mobilePhone'] == null ? undefined : json['mobilePhone'],
        'email': json['email'] == null ? undefined : json['email'],
        'notifications': json['notifications'] == null ? undefined : json['notifications'],
    };
}

export function MatrixCareHomeHealthCreatePatientInputToJSON(json: any): MatrixCareHomeHealthCreatePatientInput {
    return MatrixCareHomeHealthCreatePatientInputToJSONTyped(json, false);
}

export function MatrixCareHomeHealthCreatePatientInputToJSONTyped(value?: MatrixCareHomeHealthCreatePatientInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businessUnitId': value['businessUnitId'],
        'businessUnitName': value['businessUnitName'],
        'lineOfBusinessId': value['lineOfBusinessId'],
        'lineOfBusinessName': value['lineOfBusinessName'],
        'lineOfBusinessType': value['lineOfBusinessType'],
        'startingCertPeriod': value['startingCertPeriod'],
        'facilityDischargeTypeId': value['facilityDischargeTypeId'],
        'isShortStayAcuteHospital': value['isShortStayAcuteHospital'],
        'forObservationOnly': value['forObservationOnly'],
        'referralSourceId': value['referralSourceId'],
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'referralDate': value['referralDate'],
        'scheduledSocDate': value['scheduledSocDate'],
        'physicianOrderedSocDate': value['physicianOrderedSocDate'],
        'facilityDischargeDate': value['facilityDischargeDate'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'suffix': value['suffix'],
        'ssn': value['ssn'],
        'dateOfBirth': value['dateOfBirth'],
        'age': value['age'],
        'nickname': value['nickname'],
        'preferredPronouns': value['preferredPronouns'],
        'raceId': value['raceId'],
        'ethnicityId': value['ethnicityId'],
        'genderId': value['genderId'],
        'maritalStatusId': value['maritalStatusId'],
        'livesAloneId': value['livesAloneId'],
        'sexualOrientationId': value['sexualOrientationId'],
        'genderIdentityId': value['genderIdentityId'],
        'religionId': value['religionId'],
        'homePhone': value['homePhone'],
        'mobilePhone': value['mobilePhone'],
        'email': value['email'],
        'notifications': value['notifications'],
    };
}

